
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/selection",
      function () {
        return require("private-next-pages/selection/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/selection"])
      });
    }
  